import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { Service } from '../org-vdc-wizard.service';
let $ = require('jquery');
import { AppState } from '../../../../../app.service';
import { NgForm } from '@angular/forms';
import { NgModule } from '@angular/core';
import { SharedService } from '../shared-service';
import { Subscription } from 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
const _ = require('lodash');

@Component({
  selector: 'storage-profile-edit-component',
  styles: [require('./storage-profile.scss')],
  template: require('./storage-profile.component.html'),
  providers: [
    Service, TranslateService
  ]
})

export class StorageProfileEditComponent {
  public thisComponent: any;
  public editData: any;
  public defaultChecked: boolean = false;

  private isTranslationready: boolean = true;
  private subscribeHandler;
  private sddcPool: any = [];
  private showIops: boolean = true;
  private selectedStorageProfile: any;
  private allStorageProfiles: any;
  private showRemoveButton: boolean = false;
  private templateID: number;
  private sService: SharedService;
  private sValues: any;
  private tmp: any;
  private isWizardOpen: boolean = false;
  private selectedPVdcs: any;
  private providerVdcStorageProfile: any;
    private subscription: Subscription;
  private dataModel = {
      name: '',
      default : true,
      diskIopsDefault: 0,
      iopsSettings: {
          diskIopsDefault: 0,
          enabled: false,
          storageProfileIopsLimit: 0
      },
      objectId: '',
      storage : 0,
      storageProfileIopsLimit: 0,
      templateID: 0,
      isComponentValid: false,
      radioId: '',
      isDeleted: false
  };

    constructor(public appState: AppState,
                public service: Service,
                private translate: TranslateService,
                ss: SharedService) {
        this.sService = ss;
        translate.use(GlobalVariables.LOCALE);

    }

    ngOnInit() {
      this.dataModel.default = this.defaultChecked ? true : false;
      this.dataModel.templateID = this.templateID;
            this.dataModel.radioId = 'radSetDefault_' + this.templateID;
        if (this.templateID && this.templateID > 0) {
            this.showRemoveButton = true;
            this.dataModel.default = false;
        }
        let data = this.editData;

        if (data) {
            this.showIops = false;
            this.dataModel.name = data.name;
            this.dataModel.storage = (data.units && data.units == "MB" && Number(data.limit) > 0) ? (Number(data.limit)/1024).toFixed(2) : data.limit;
            this.dataModel.default = (data.default) ? true : false;
            this.dataModel.objectId = data.objectId;
            if (data.iopsSettings && data.iopsSettings.enabled) {
                this.showIops = true;
                this.dataModel.iopsSettings.enabled = true;
                this.dataModel.iopsSettings.diskIopsDefault
                    = data.iopsSettings.diskIopsDefault;
                this.dataModel.iopsSettings.storageProfileIopsLimit
                    = data.iopsSettings.diskIopsMax;
            }
          if (this.providerVdcStorageProfile) {
              this.selectedStorageProfile = null;
              for (let i = 0; i < this.providerVdcStorageProfile.length; i++) {
                  if (this.providerVdcStorageProfile[i].name === data.name) {
                      this.selectedStorageProfile = this.providerVdcStorageProfile[i];
                      break;
                  }
              }

              this.allStorageProfiles = this.providerVdcStorageProfile;
              this.sService.setValue(this.templateID, this.dataModel, null);
              this.emitUpdates(false);

          }
            this.sService.setValue(this.templateID, this.dataModel, false);
            this.sService.shareDataUpdate();
        } else {

        }
    }



    selStorageProfileChange(event) {
        this.showIops = (typeof event.iopsEnabled !== 'undefined'
                    && event.iopsEnabled === 'true') ? true : false;
        this.dataModel.iopsSettings.enabled = this.showIops;
        this.dataModel.iopsSettings.diskIopsDefault = 0;
        this.dataModel.iopsSettings.storageProfileIopsLimit = 0;
        this.dataModel.isComponentValid = false;
        this.dataModel.name = event.name;
        this.dataModel.objectId = this.getObjectIdFromHref(event.href);
        this.emitUpdates(false);
  }

  getObjectIdFromHref(href: string) {
        if (!href) {
            return '';
        }
        let pos = href.lastIndexOf('/');
        if (pos) {
            return href.substring(pos + 1);
        }
  }

  setStepValid() {
    this.dataModel.isComponentValid = true;
    let data = this.dataModel;

    if (isNaN(data.storage) || data.storage < 1 || data.storage % 1 !== 0) {
        this.dataModel.isComponentValid = false;
        return;
    }
    if (data.iopsSettings.enabled) {
        var diskIopsDefault = data.iopsSettings.diskIopsDefault ? data.iopsSettings.diskIopsDefault : null;
        var storageProfileIopsLimit = data.iopsSettings.storageProfileIopsLimit ? data.iopsSettings.storageProfileIopsLimit : null;
        if ( (isNaN(diskIopsDefault) || diskIopsDefault < 1 || diskIopsDefault % 1 !== 0) ||
        (isNaN(storageProfileIopsLimit) || storageProfileIopsLimit < 1 || storageProfileIopsLimit % 1 !== 0) ) {
              this.dataModel.isComponentValid = false;
        }
    }
    return;
  }

  emitUpdates(resetChecked: Boolean) {
    this.setStepValid();
    this.sService.setValue(this.templateID, this.dataModel, resetChecked);
    this.sService.shareDataUpdate();
  }
  removeStorageProfile() {
    this.dataModel.isDeleted = true;
    this.sService.shareComponentDelete(this.dataModel,  this.templateID);
  }

  radioChange(event) {
    this.dataModel.radioId = event.target.id;
    this.dataModel.default = event.target.checked;
    this.emitUpdates(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/storage-profile/storage-profile-edit.component.ts